/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Samples_Total_CountInputs */

const en_samples_total_count = /** @type {(inputs: Samples_Total_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} total)`)
};

const es_samples_total_count = /** @type {(inputs: Samples_Total_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} total)`)
};

/**
* | output |
* | --- |
* | "({count} total)" |
*
* @param {Samples_Total_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_total_count = /** @type {((inputs: Samples_Total_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Total_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_total_count(inputs)
	return es_samples_total_count(inputs)
});